import { styled as i } from "styled-components";
import { MediaQuery as m } from "../../../../styles/variables.js";
import { Image as e } from "../../../../components/Image/index.js";
const a = i(e)`
  display: inline-block;
  width: 100%;
  height: 100%;
  max-width: 50vw;
  max-height: 300px;
  border-radius: 4px;
  margin: 8px 0;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    max-height: 300px;
  }

  @media ${m.SCREEN_MD_UP} {
    max-width: 300px;
  }
`;
export {
  a as Image
};
